import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {PagesRoutingModule} from './pages-routing.module';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {NgSwitcheryModule} from 'angular-switchery-ios';
import {PlyrModule} from 'ngx-plyr';
import {NgxMaskModule} from 'ngx-mask';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {QuillModule} from 'ngx-quill';
import {NgxPaginationModule} from 'ngx-pagination';
import {ImageCropperModule} from 'ngx-image-cropper';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker'; // REMOVER DEPOIS
import {defineLocale} from 'ngx-bootstrap/chronos';
import {enGbLocale, esLocale, ptBrLocale} from 'ngx-bootstrap/locale';
import {ChartsModule} from 'ng2-charts';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NgSelectModule} from '@ng-select/ng-select';
import {AutosizeModule} from 'ngx-autosize';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgCircleProgressModule} from 'ng-circle-progress';
import {NgxMapboxGLModule} from 'ngx-mapbox-gl';
// services
import {NgxImageCompressService} from 'ngx-image-compress';

// pages
import {PagesComponent} from './pages.component';
import {TranslateModule} from '@ngx-translate/core';
import {ComponentsModule} from '../components/components.module';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {PrincipalService} from '../services/principal.service';

defineLocale('pt-br', ptBrLocale);
defineLocale('en', enGbLocale);
defineLocale('es', esLocale);

// componentes

@NgModule({
    imports: [
        ComponentsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgScrollbarModule,
        NgxSkeletonLoaderModule,
        NgSwitcheryModule,
        TooltipModule,
        PlyrModule,
        NgxMaskModule.forRoot(),
        DragDropModule,
        QuillModule.forRoot(),

        NgxPaginationModule,
        ImageCropperModule,
        ChartsModule,
        NgxDatatableModule,
        AutosizeModule,
        BsDatepickerModule.forRoot(),
        NgSelectModule,
        NgCircleProgressModule.forRoot({}),
        NgxMapboxGLModule.withConfig({
            // Optional, can also be set per map (accessToken input of mgl-map)
            accessToken: 'pk.eyJ1IjoidGFpbmhhcGxheSIsImEiOiJja3NrZ2RqaDIwbWdsMndwYzViMm81Y2xhIn0.IZn1yTqvTdy3anW6oTzlOQ',
        }),
        NgbModule,
        PagesRoutingModule,
    ],
    declarations: [
        PagesComponent
    ],
    providers: [
        // WebSocketService,
        NgxImageCompressService,
        PrincipalService,
    ],
    exports: [
        PagesComponent
    ],
    entryComponents: [
    ]
})
export class PagesModule { }
